export function getPageBottomPosition() {
  if (typeof window === 'undefined') {
    return 0;
  }
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const clientHeight = window.innerHeight;

  return scrollTop + clientHeight;
}
